// import readXlsxFile from 'read-excel-file';
import React, { Component } from 'react';
import { withAuthorization } from '../Session';
import { Container, Row, Col, Button } from 'react-bootstrap';
import 'date-fns';
import Spinner from 'react-bootstrap/Spinner';

import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import ProfileTags from './ProfileTags';

import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';

class Summary extends Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            alert: 0,
            TotalOPSStore: 0,
            TotalOrderStore: 0,
            TotalStoreAssigend: 0,
            TotalEarning: 0,
            TotalOrder: 0,
            ActiveStore: 0,
            alertMessage: '',
            flag: false,
            flag1: false,
            showLoading: true,
            storedata: [],
            storeTag: '',
            sheetsFlag: 0,
            step1RevStore: 0,
            step2RevStore: 0,
            step3RevStore: 0,
            step4RevStore: 0,
            selectedTab: '',
            uploadSpinner: false,
            fromDate: this.getFormattedDate('firstDay'),
            toDate: this.getFormattedDate('lastDay'),
            storeSheetdata: ['Fee_Orders'],
            lastUpdatedOrders: '',
            showStoreTags: false,
            showLocked: false,
            cashedView: true
        };
    }

    toggleBlockStatus = () => {
        if (this._isMounted) {
            this.setState({
                showStoreTags: false,
                showLocked: !this.state.showLocked
            });
        }
        setTimeout(() => {
            this.loadData();
        }, 500);
    };
    getFormattedDate(dateType) {
        var date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        if (dateType == 'firstDay') {
            var firstDay = new Date(y, m, 1);
        } else {
            var firstDay = new Date(y, m + 1, 0);
        }
        var dd = String(firstDay.getDate()).padStart(2, '0');
        var mm = String(firstDay.getMonth() + 1).padStart(2, '0');
        var yyyy = firstDay.getFullYear();

        var newdate = yyyy + '-' + mm + '-' + dd;
        return newdate;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadCashedData();
        this.loadData();
    }


    async loadCashedData(){
        
        let bodyData = {
            UniqeID: this.props.user.ProfileUniqeID,
            userRole:this.props.role == 'StoreOwners' ? 'StoreOwner' : this.props.role,
        };

        await RestServices.getCashedStoreStatics(
            localStorage.getItem('FirebaseToken'),
            bodyData
        ).then((response) => response.json())
        .then(async (responseData) => {
            
            if (this._isMounted) {
                this.setState({ TotalStoreAssigend: responseData.TotalStoreAssigend ,
                     TotalOPSStore: responseData.TotalOPSStore ,
                     TotalOrderStore: responseData.TotalOrderStore ,
                      ActiveStore: responseData.ActiveStore , 
                      showLoading: false,cashedView:true,});

                
            }

        })

    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    async loadData() {
        var userRole = this.props.role
        if (this.props.role === 'Admins') {
            var userRole = 'Admin';
        }
        if (this.props.role === 'Employees') {
            var userRole = 'Employee';
        }
        if (this.props.role === 'Distributors') {
            var userRole = 'Distributor';
        }
        if (this.props.role === 'StoreCP') {
            var userRole = 'StoreCP';
        }
        if (this.props.role === 'StoreOwners') {
            var userRole = 'StoreOwner';
        }

        let bodyData = {
            UniqeID: this.props.user.ProfileUniqeID,
            userRole:userRole,
            showLocked: this.state.showLocked ? this.state.showLocked : false
        };
        

        await RestServices.getAllStoresEmailMappedWith(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then(async (AllStoreTagsData) => {
                if (AllStoreTagsData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: AllStoreTagsData.error,
                            showLoading: false
                        });
                    }
                } else {
                    if (this._isMounted) {
                        this.setState({
                            TotalStoreAssigend: AllStoreTagsData.length,
                            alert: 0
                        });
                    }
                    if (AllStoreTagsData.length > 0) {
                        this.fetchStoreStatics(AllStoreTagsData);
                    } else {
                        if (this._isMounted) {
                            this.setState({ showLoading: false ,cashedView: false});
                        }
                    }
                }
            })

            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }
    async fetchStoreStatics(AllStoreTagsData) {
        let StoreRev = 0;
        let storeTagsData = [];
        let TotalTOV = 0;
        let TotalActiveStore = 0;
        let TotalOrder = 0;

        let bodyData = {
            storeTag: AllStoreTagsData
        };
        await RestServices.thisMonthlyStoreStatics(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then(async (responseData) => {
                if (responseData) {
                    TotalActiveStore = responseData.length;

                    await responseData.forEach(async (storetag) => {
                        TotalTOV =
                            parseFloat(TotalTOV) +
                            parseFloat(storetag.OpsTotal);
                        TotalOrder = TotalOrder + storetag.OrderTotal;
                    });

                    if (this._isMounted) {
                        this.setState({ TotalOPSStore: TotalTOV });
                        this.setState({ TotalOrderStore: TotalOrder });
                        this.setState({ ActiveStore: TotalActiveStore });
                        this.setState({ showLoading: false ,cashedView:false});
                        let bodyData = {
                            UniqeID: this.props.user.ProfileUniqeID,
                            userRole:this.props.role == 'StoreOwners' ? 'StoreOwner' : this.props.role,
                            TotalStoreAssigend:this.state.TotalStoreAssigend,
                            TotalOPSStore: TotalTOV,
                            TotalOrderStore: TotalOrder,
                            ActiveStore: TotalActiveStore
                        };
                        await RestServices.updateStoreStatics(
                            localStorage.getItem('FirebaseToken'),
                            bodyData
                        ).then((response) => response.json())
                        .then(async (responseData) => {
                            
                        })

                    }
                }
            });
    }
    reLoadData = () => {
        if (this._isMounted) {
            this.loadData();
        }
    };
    toggleStoreTagsView = () => {
        if (this._isMounted) {
            this.setState({ showStoreTags: !this.state.showStoreTags });
        }
    };

    render() {
        return (
            <div>
                {this.state.showLoading && <Spinner animation="border" />}
                {/*<Row>
                    <Button style={{marginLeft:"1rem", marginRight:"1rem"}} variant="primary"  onClick={this.toggleBlockStatus}>
                    Toggle 
                    {this.state.showLocked &&<LockIcon />}
                    {!this.state.showLocked &&<LockOpenIcon />}
                    </Button>
                </Row>
                 <div><hr/></div>*/}

                 {this.state.cashedView &&<div>
                    <Row>
                    <Button style={{marginLeft:"1rem", marginRight:"1rem"}} variant="primary"  onClick={this.reLoadData}>
                    Reload 
                    </Button>
                </Row>
                <div><hr/></div>
                </div>}

                <Row className="center_align">
                    <Col>
                        <h6>Total Stores Assigned</h6>
                        <h5>{this.state.TotalStoreAssigend}</h5>
                        <Button
                            variant="primary"
                            onClick={this.toggleStoreTagsView}
                        >
                            View
                        </Button>
                    </Col>
                    <Col>
                        <h6>No: of Active Stores</h6>
                        <h5>{this.state.ActiveStore}</h5>
                    </Col>
                    <Col>
                        <h6>Total TOV</h6>
                        <h5> {this.state.TotalOPSStore.toFixed(2)}</h5>
                    </Col>

                    <Col>
                        <h6>Total Orders</h6>
                        <h5> {this.state.TotalOrderStore}</h5>
                    </Col>

                    {this.state.ActiveStore > 0 && (
                        <Col>
                            <h6>Active Store Count % </h6>
                            <h5>
                                {(
                                    (this.state.ActiveStore /
                                        this.state.TotalStoreAssigend) *
                                    100
                                ).toFixed(2)}
                            </h5>
                        </Col>
                    )}

                    {this.state.ActiveStore == 0 && (
                        <Col>
                            <h6>Active Store Count % </h6>
                            <h5>0</h5>
                        </Col>
                    )}
                </Row>
                <div>
                    <hr />
                </div>
                <p>
                    {this.props.showStoreTags} {this.state.showLocked}
                </p>
                {this.state.showStoreTags && (
                    <ProfileTags
                        showLocked={this.state.showLocked}
                        selectedUserRole={this.props.role}
                        UniqeID={this.props.user.ProfileUniqeID}
                        {...this.props}
                    />
                )}
            </div>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(Summary);
